import { useParams } from "react-router-dom";
import { useLearner } from "../contexts/LearnerContext";
import type { Course } from "../types/learning";

/** Resolves the course pair encoded in the URL as /:from/:to. */
export function useRouteCourse(): Course | undefined {
  const { from = "", to = "" } = useParams();
  const { courses } = useLearner();
  return courses.find((c) => c.base === from && c.target === to);
}
